import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  filterContainer: {
    backgroundColor: theme.palette.gray20.main,
    borderRadius: "4px",
  },
  topBorder: {
    borderTop: `2px solid ${theme.palette.gray40.main}`,
  },
}));

export default useStyles;
